var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ModalAFY, FormAddAppointmentActionAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var ModalAddAppointmentAction = function (props) {
    return (_jsx(ModalAFY, __assign({ title: "", name: "", openModal: props.openModalAddAppointmentAction, onClose: function () {
            props.setOpenModalAddAppointmentAction(false);
        }, minWidthModal: "1300px", heightModal: "640px", backgroundColor: "#FFFFFF", closeModalOutside: true }, { children: _jsx(FormAddAppointmentActionAFY, __assign({}, props.formAppointmentActionProps, { filters: [], onChangeNumberValue: function noRefCheck() { }, onChangeSelect: function () { }, onClickCancel: function () { return props.setOpenModalAddAppointmentAction(false); }, onNext: function (data) {
                props.handleSubmitAppointmentAction(data);
            } })) })));
};
